import { cn } from "@/lib/utils";

/**
 * Fixed header clearance from the viewport top (announcement bar + nav).
 * Set in `globals.css` and refined at runtime by `NavOffsetSync`.
 */
export const NAV_OFFSET_VAR = "var(--nav-offset)";

/** Figma hero breathing room below the nav (32 / 48 / 80). */
export const HERO_NAV_GAP_VAR = "var(--hero-nav-gap)";

/**
 * Document-flow spacer under fixed announcement bar + nav.
 * Use once per page when the first block does not apply hero padding itself.
 */
export const navClearanceSpacerClass =
  "h-[var(--nav-offset)] shrink-0 [transition:height_180ms_cubic-bezier(0.2,0.8,0.2,1)] motion-reduce:transition-none";

/**
 * Full-bleed heroes where fixed chrome overlays the section background.
 * Pulls the section up, then pads content back down by the synced offset.
 */
export const heroOverlayNavClearanceClass =
  "-mt-[var(--nav-offset)] pt-[var(--nav-offset)] [transition:padding-top_180ms_cubic-bezier(0.2,0.8,0.2,1),margin-top_180ms_cubic-bezier(0.2,0.8,0.2,1)] motion-reduce:transition-none";

/**
 * Top padding for page heroes on plain elements (`section`, `main` children).
 * `!important` so it wins over responsive `py-*` utilities.
 */
export const heroBelowNavPaddingClass =
  "!pt-[calc(var(--nav-offset)+var(--hero-nav-gap))] [transition:padding-top_180ms_cubic-bezier(0.2,0.8,0.2,1)] motion-reduce:transition-none";

export function cnHeroBelowNavPadding(className?: string) {
  return cn(heroBelowNavPaddingClass, className);
}

/**
 * Nav clearance for heroes built with `Section` (which defaults to `py-12`
 * `md:py-16`). Resets vertical padding, then applies the shared hero top inset.
 */
export function cnSectionHeroBelowNav(className?: string) {
  return cn(
    "!py-0 !pt-[calc(var(--nav-offset)+var(--hero-nav-gap))] [transition:padding-top_180ms_cubic-bezier(0.2,0.8,0.2,1)] motion-reduce:transition-none",
    className
  );
}
